import { useRouteError, isRouteErrorResponse } from "@remix-run/react";

import { ErrorView } from "./components/errorView/ErrorView";
import { sendMessageToHost } from "./utils/events";
import { useMountEffect } from "./hooks/useMountEffect";

/**
 * This is the fallback error boundary for the entire app.
 * It will catch any errors not already caught by a more
 * specific error boundary.
 */
export function ErrorBoundary() {
  const error = useRouteError();

  // Send an error message to the mobile-native app so that
  // it can present the appropriate UI.
  useMountEffect(() => {
    const message = isRouteErrorResponse(error)
      ? error.statusText
      : (error as Error).message ?? "Unknown error";

    sendMessageToHost({ error: { unhandled: { message } } });
  });

  return (
    <ErrorView
      status={isRouteErrorResponse(error) ? error?.status : undefined}
    />
  );
}
